module.exports = __webpack_public_path__ + "img/video-player/yay-78e2ff9834cdf83a5a66612fcbe834df.png";